<template>
    <div class="modal fade" id="selectedCartModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">

            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">محصول به سبد خرید شما اضافه شد</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-9">
                                <div class="main-a-s">
                                    <img :src="productInfo.PicPath" />
                                    <span class="name-d">  {{productInfo.Name}} </span>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="price-mo">
                                    <div v-if="productInfo.Price != 0" :class="[(productInfo.DiscountPercent == 0) ? 'price-main-at':'price-main']">
                                        <div class="price-value">
                                            <span v-if="productInfo.DiscountPercent == 0"> {{(productInfo.Price ) | formatNumber }}</span>
                                            <span class="discount" v-if="productInfo.DiscountPercent > 0">
                                                {{((productInfo.Price  ) - (((productInfo.Price ) * productInfo.DiscountPercent)/100))  | formatNumber  }}
                                                <span class="discountvalue" v-if="productInfo.DiscountPercent > 0">   {{(productInfo.Price) | formatNumber}}  <span class="discountvalue-t"> تومان </span></span>

                                            </span>
                                            <span class="price-currency"> تومان </span>
                                        </div>
                                        <div v-if="productInfo.DiscountPercent != 0" class="price-discount">
                                            <span>
                                                {{productInfo.DiscountPercent}}
                                            </span>
                                            <span>%</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <hr />
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6 col-sm-6 col-xs-12">
                                <span class="sho-h">
                                    شما {{  cart.CartInfo.CartDetailsCount }}  کالا در سبد خرید دارید
                                </span>
                            </div>
                            <div class="col-12 col-md-6 col-sm-6 col-xs-12">
                                <div class="b-price-t">
                                    <span>
                                        جمع سبد خرید
                                    </span>
                                    <span>
                                        {{ cart.CartInfo.AmountPayable | formatNumber}} تومان
                                    </span>
                                </div>

                            </div>
                        </div>
                        <div class="row" v-if="cart.CartInfo.IsApplyFreeDelivery">
                            <div class="col-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="center fd-pish"><span>توجه : سود شما ارسال رایگان با پست پیشتاز</span></div>
                            </div>

                        </div>
                        <div class="row" v-if="showPreFactorForm">
                            <div class="col-12 col-md-12 col-sm-12 col-xs-12">
                                <div class="">
                                    <hr />
                                </div>
                                <div class="PreFactorForm">
                                    <center><p class="title">پیش فاکتور</p></center>
                                    <ul style="display: flex; justify-content: center" class="nav nav-tabs sse-hover" id="myTab" role="tablist">
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link active" id="home-tab" data-toggle="tab" data-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">دریافت پیش فاکتور فروشگاهی</button>
                                        </li>
                                        <li class="nav-item" role="presentation">
                                            <button class="nav-link" id="profile-tab" data-toggle="tab" data-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">دریافت پیش فاکتور سازمانی</button>
                                        </li>
                                    </ul>

                                    <div class="tab-content">
                                        <div class="tab-pane active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                            <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                                                <li v-for="error in errors.collect('store')">{{ error }}</li>
                                            </ul>
                                            <form @submit.prevent="createPreFactoreStore" data-vv-scope="store">
                                                <div class="row">
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons users_single-02"></i></label>
                                                            <input v-model="storeFactorinfo.FullName" v-validate="{required: true , max:100}" data-vv-as="نام نام خانوادگی" class="input-field text-right" type="text" placeholder="نام نام خانوادگی خود را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons tech_mobile"></i></label>
                                                            <input  @input="storeFactorinfo.MobNo = convertPersianToEnglish(storeFactorinfo.MobNo)" v-model="storeFactorinfo.MobNo" v-validate="{required: true ,numeric: true , digits :11}" data-vv-as="شماره موبایل" class="input-field text-right" type="text" placeholder="شماره موبایل خود را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons location_pin"></i></label>
                                                            <input v-model="storeFactorinfo.ProvinceName" v-validate="{required: true , max:50}" data-vv-as="استان" class="input-field text-right" type="text" placeholder="استان را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons location_pin"></i></label>
                                                            <input v-model="storeFactorinfo.CityName" v-validate="{required: true , max:50}" data-vv-as="شهر" class="input-field text-right" type="text" placeholder="شهر را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons location_pin"></i></label>
                                                            <textarea v-model="storeFactorinfo.Address" v-validate="{required: true , required: true, max:300}" data-vv-as=" آدرس" rows="2" class="input-field text-right" type="text" placeholder="آدرس را وارد نمایید"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 ">
                                                        <center>
                                                            <button style="padding:10px;font-size:14px;" type="submit" class="btn btn-info">دانلود پیش فاکتور فروشگاهی</button>
                                                        </center>
                                                    </div>
                                                </div>
                                            </form>

                                        </div>
                                        <div class="tab-pane" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                            <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                                                <li v-for="error in errors.collect('sazmani')">{{ error }}</li>
                                            </ul>
                                            <form @submit.prevent="createPreFactoreSazmani" data-vv-scope="sazmani">
                                                <div class="row">

                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons users_single-02"></i></label>
                                                            <input v-model="sazmaniFactorinfo.FullName" v-validate="{required: true , max:100}" data-vv-as="نام نام خانوادگی" class="input-field text-right" type="text" placeholder="نام نام خانوادگی خود را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons tech_mobile"></i></label>
                                                            <input  @input="sazmaniFactorinfo.MobNo = convertPersianToEnglish(sazmaniFactorinfo.MobNo)" v-model="sazmaniFactorinfo.MobNo" v-validate="{required: true ,numeric: true , digits :11}" data-vv-as="شماره موبایل" class="input-field text-right" type="text" placeholder="شماره موبایل خود را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons shopping_tag-content"></i></label>
                                                            <input @input="sazmaniFactorinfo.NationalCode = convertPersianToEnglish(sazmaniFactorinfo.NationalCode)" v-model="sazmaniFactorinfo.NationalCode" v-validate="{required: true ,numeric: true }" data-vv-as="شناسه ملی" class="input-field text-right" type="text" placeholder="شناسه ملی را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons business_bank"></i></label>
                                                            <input v-model="sazmaniFactorinfo.CompanyName" v-validate="{required: true , max:50}" data-vv-as="نام شرکت" class="input-field text-right" type="text" placeholder="نام شرکت را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons location_pin"></i></label>
                                                            <input v-model="sazmaniFactorinfo.ProvinceName" v-validate="{required: true , max:50}" data-vv-as="استان" class="input-field text-right" type="text" placeholder="استان را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons location_pin"></i></label>
                                                            <input v-model="sazmaniFactorinfo.CityName" v-validate="{required: true , max:50}" data-vv-as="شهر" class="input-field text-right" type="text" placeholder="شهر را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-6 col-xs-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons location_bookmark"></i></label>
                                                            <input v-model="sazmaniFactorinfo.PostalCode" v-validate="{digits:10 }" data-vv-as="کد پستی" class="input-field text-right" type="text" placeholder="کد پستی را وارد نمایید">
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12">
                                                        <div class="form-account-row">
                                                            <label class="input-label"><i class="now-ui-icons location_pin"></i></label>
                                                            <textarea v-model="sazmaniFactorinfo.Address" v-validate="{required: true , required: true, max:300}" data-vv-as=" آدرس" rows="2" class="input-field text-right" type="text" placeholder="آدرس را وارد نمایید"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-sm-12 col-md-12 ">
                                                        <center>
                                                            <button style="padding:10px;font-size:14px;" type="submit" class="btn btn-info">دانلود پیش فاکتور سازمانی</button>
                                                        </center>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        
                                    </div>

                                
                                </div>
                            </div>
                        </div>
                        <div class="row btn-box-c">
                            <!--<div v-if="baseInfo.IsActiveOrder" class="col-4 col-md-4 col-sm-4 col-xs-12">
                                <div >
                                    <router-link v-if="isUserLogined" to="/chooseAddress" class="btn btn-reject" data-dismiss="modal">تکمیل خرید</router-link>
                                    <a v-else href="/login" class="btn btn-reject">ورود و ثبت سفارش</a>
                                </div>
                            </div>-->
                            <div class="col-12 col-md-4 col-sm-4 col-xs-12">
                                <div class="text-left">
                                    <center>
                                        <a href="/cart" class="btn btn-save">مشاهده سبد خرید</a>
                                    </center>
                                </div>
                            </div>
                            <div v-if="baseInfo.IsShowPreOrderBtn && productInfo.IsShowPreOrderBtn" class="col-12 col-md-4 col-sm-4 col-xs-12">
                                <div class="text-left">
                                    <center>
                                        <button @click="togglePreFactorForm" class="btn btn-default"> {{showPreFactorForm ? 'بستن پیش فاکتور' : 'دریافت پیش فاکتور'}} </button>

                                    </center>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../module/httpUtility";
    export default {
        data() {
            return {
                isUserLogined: false,
                showPreFactorForm: false,
                sazmaniFactorinfo: {},
                storeFactorinfo: {},
                isShowSppiner: false
            }
        },
        props: {
            productInfo: {
                type: Object,
            },
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            convertPersianToEnglish(str) {
                if (!str) return '';
                const persianNums = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
                const englishNums = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
                let result = '';
                for (let i = 0; i < str.length; i++) {
                    const index = persianNums.indexOf(str[i]);
                    result += index >= 0 ? englishNums[index] : str[i];
                }
                console.log(result);
                return result;
            },
            togglePreFactorForm() {
                this.showPreFactorForm = !this.showPreFactorForm;
            },
            createPreFactoreSazmani() {
                this.$validator.validateAll('sazmani').then(valid => {
                    if (valid) {
                        this.isShowLoader = true;
                        this.sazmaniFactorinfo.IsStore = false;
                        this.sazmaniFactorinfo.HashCartId = this.cart.HashCartId;

                        httpPromise(this, '/v1/Orders/Orders/PreOrderOperation', 'post_2', JSON.stringify(this.sazmaniFactorinfo),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                this.isShowLoader = false;
                                this.sazmaniFactorinfo = {};
                                $(function () {
                                    const url = response.data.Value;
                                    window.open(url, '_blank');

                                });
                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowLoader = false;
                            });
                    }
                });
            },

            createPreFactoreStore() {
                this.$validator.validateAll('store').then(valid => {
                    if (valid) {
                        this.isShowLoader = true;
                        this.storeFactorinfo.IsStore = true;
                        this.storeFactorinfo.HashCartId = this.cart.HashCartId;
                        httpPromise(this, '/v1/Orders/Orders/PreOrderOperation', 'post_2', JSON.stringify(this.storeFactorinfo),
                            response => {
                                toastr.remove();
                                toastr.success(response.data.Message);
                                this.isShowLoader = false;
                                this.storeFactorinfo = {};
                                $(function () {

                                    const url = response.data.Value;
                                    window.open(url, '_blank');

                                });

                            },
                            response => {
                                toastr.remove();
                                toastr.error(response.data.Message);
                                this.isShowLoader = false;
                            });
                    }
                });
            },

        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        }
    }
</script>

<style scoped>
    .sse-hover li button:hover {
        cursor: pointer;
    }
    .fd-pish {
        margin: 10px;
        color: #c1c139;
    }

        .fd-pish span {
            display: inline-block;
            border-radius: 8px;
            padding: 10px;
            border: 1px dashed #c1c139;
        }

    .b-price-t {
        text-align: left;
    }

        .b-price-t span {
            font-size: 14px;
            font-weight: 600;
        }

    .sho-h {
        font-size: 13px;
        font-weight: 500;
        color: #b08c8c;
    }

    .price-mo .price-main {
        padding: 20px 20px 0 0;
    }

    .price-mo .price-value {
        font-size: 20px;
        line-height: 35px;
        float: right;
    }

    .price-mo .discount::after {
        content: "";
        width: 100%;
        position: absolute;
        left: 0px;
        border-top: 1px solid #c6c6c6;
        -webkit-transform: rotate(-30deg);
        transform: rotate(0deg);
        top: -1px;
    }

    .price-mo .discount {
        display: inline-block;
        position: relative;
        font-size: 14px;
    }

    .price-mo .discountvalue {
        position: absolute;
        top: -19px;
        right: 1px;
        font-size: 14px;
        color: #c6c6c6;
    }

    .price-mo .discount::after {
        content: "";
        width: 100%;
        position: absolute;
        left: 0px;
        border-top: 1px solid #c6c6c6;
        -webkit-transform: rotate(-30deg);
        transform: rotate(0deg);
        top: -1px;
    }

    .price-mo .discountvalue-t {
        position: absolute;
        left: -50px;
    }

    .price-mo .discountvalue {
        font-size: 14px;
        color: #c6c6c6;
    }

    .price-mo .price-currency {
        font-size: 14px;
        line-height: 1.294;
    }









    .modal-content .modal-header {
        background-color: #fff !important;
        border: 1px solid #ddd !important;
    }

    .main-a-s .name-d {
        font-size: 13px;
        color: #06d
    }

    .price-discount {
        margin-right: 20px;
    }

    @media (min-width: 576px) {

        .modal-dialog {
            max-width: 600px;
            margin: 1.75rem auto;
        }
    }

    .btn-box-c {
        background-color: #e8d7d7;
        padding-top: 15px;
        padding-bottom: 8px;
        margin-top: 15px;
    }

    .modal-content .modal-body {
        padding-top: 25px;
        padding-right: 0;
        padding-bottom: 0;
        padding-left: 0;
    }

    .main-a-s {
        display: flex;
        justify-content: right;
        align-items: center;
        flex-direction: row;
    }

    .price-mo {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .main-a-s .name-d {
    }

    .main-a-s img {
        margin-left: 15px;
        width: 90px;
    }

    .div-loader {
        position: absolute;
        width: 102%;
        height: 100%;
        top: 0;
        left: -1px;
        background-color: #ddd;
        padding-top: 6px;
        text-align: center
    }

        .div-loader img {
            width: 40px;
        }

    .btn-estelam-main {
        position: relative;
    }

    .modal-content {
        border-radius: unset;
    }

    .modal-content {
        border-radius: 8px;
    }

    .wiki-sign {
        cursor: pointer;
        position: unset;
        margin-right: 0px;
        width: unset;
        height: unset;
        display: unset;
        margin-top: unset;
        vertical-align: middle;
    }

        .wiki-sign::after {
            content: "\ea04";
            font-family: 'Nucleo Outline';
            color: #ababab;
            font-size: 18px;
            line-height: 1.048;
            position: unset;
            top: 50%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
        }

    .title-message {
        text-align: right;
        margin-bottom: 10px;
    }

    .title {
        margin-left: 10px;
    }

    .carrierName {
        font-weight: bold;
        font-size: 15px;
        color: #666
    }

    .okStatusMessage {
        font-size: 12px;
        padding: 10px 20px 10px 20px;
        background-color: #95db95;
        color: #fff;
        font-weight: bold;
        width: 100%;
        display: block;
    }

    .notOkStatusMessage {
        font-size: 12px;
        padding: 10px 20px 10px 20px;
        background-color: #cc5e5e;
        color: #fff;
        font-weight: bold;
        display: block;
    }

    .radio label::before {
        right: 15px;
    }

    .radio input[type="radio"]:checked + label::after {
        right: 18px
    }

    .radio label::before, .radio label::after {
        right: 15px;
    }

    .content-img-radio img {
        width: 100px;
        height: 100px;
        border: 1px solid #ddd;
        border-radius: 5px;
        overflow: hidden;
        margin-bottom: 8px;
        padding: 5px;
    }

    .modal-content .modal-header {
        background-color: #aec7f4;
    }

    .modal-content .modal-header {
        background-color: #aec7f4;
    }

    .modal-content .modal-header {
        border-bottom: none;
        padding-top: 8px;
        padding-right: 24px;
        padding-bottom: 13px;
        padding-left: 24px;
    }

    .modal h5 {
        font-size: 14px;
        font-weight: 500;
        color: #b08c8c;
    }

    .modal .modal-header .close {
        color: #b08c8c !important;
    }

    .btn-estelam {
        width: 100%;
        font-size: 15px;
        font-weight: bold;
    }

    .modal-content .modal-header button {
        left: 13px;
        right: unset;
        top: 6px;
    }

    .close {
        font-size: 31px !important;
    }

    .modal .modal-header .close {
        color: #fff;
    }

    .btn-div {
        text-align: center;
    }

    .div-logo-item {
        border-bottom: 1px solid #ddd;
        padding: 25px 5px 25px 10px;
    }

    .btn-div {
        margin-top: 15px;
    }

    .price-all {
        padding: 10px 0 10px 0;
        text-align: center;
    }

    .btn-reject {
        background-color: #e36e6e !important;
    }

    .btn-save {
        background-color: #59b959 !important;
    }

    .btn-main {
        text-align: center;
    }

    @media screen and (max-width: 768px) {
        .nav-tabs {
            padding-left: 0;
            padding-right: 0;
        }
    }
</style>